<!-- Desktop Table View -->
<div *ngIf="(isMobile$ | async) === false">
  <table mat-table [dataSource]="presets" data-element="thermostat-presets-table">
    <!-- Image Column -->
    <ng-container matColumnDef="image">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngTemplateOutlet="toggleTemplate; context: { $implicit: element }"></ng-container>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Preset Name</th>
      <td mat-cell *matCellDef="let element">
        {{ element.name }}
      </td>
    </ng-container>

    <!-- Set points Column -->
    <ng-container matColumnDef="set-points">
      <th mat-header-cell *matHeaderCellDef>Set Points</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngTemplateOutlet="setPointsTemplate; context: { $implicit: element }"></ng-container>
      </td>
    </ng-container>

    <!-- Fan Column -->
    <ng-container matColumnDef="fan">
      <th mat-header-cell *matHeaderCellDef>Fan</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngTemplateOutlet="fanTemplate; context: { $implicit: element }"></ng-container>
      </td>
    </ng-container>

    <!-- Preset Type Column -->
    <ng-container matColumnDef="preset-type">
      <th mat-header-cell *matHeaderCellDef>Preset Type</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngTemplateOutlet="presetTypeTemplate; context: { $implicit: element }"></ng-container>
      </td>
    </ng-container>

    <!-- Thermostat Devices Column -->
    <ng-container matColumnDef="thermostats">
      <th mat-header-cell *matHeaderCellDef>Devices</th>
      <td mat-cell *matCellDef="let element">
        <div style="display: inline-block">
          <sbnb-thermostats
            [allThermostats]="false"
            [thermostats]="element.thermostats"
            [thermostatName]="element.name"></sbnb-thermostats>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="openPreset(row)"></tr>
  </table>
</div>

<!-- Mobile Card View -->
<div *ngIf="(isMobile$ | async) === true" class="space-y-4 mt-4" data-element="thermostat-presets-mobile">
  <mat-card
    *ngFor="let preset of presets"
    class="cursor-pointer hover:shadow-md transition-shadow"
    (click)="openPreset(preset)">
    <mat-card-content class="space-y-3">
      <!-- Header Row -->
      <div class="flex items-center justify-between">
        <h3 class="text-lg font-medium">{{ preset.name }}</h3>
        <ng-container *ngTemplateOutlet="toggleTemplate; context: { $implicit: preset }"></ng-container>
      </div>

      <!-- Set Points Row -->
      <div class="flex items-center justify-between">
        <span class="text-gray-600 text-sm">Set Points</span>
        <ng-container *ngTemplateOutlet="setPointsTemplate; context: { $implicit: preset }"></ng-container>
      </div>

      <!-- Fan Row -->
      <div class="flex items-center justify-between">
        <span class="text-gray-600 text-sm">Fan</span>
        <ng-container *ngTemplateOutlet="fanTemplate; context: { $implicit: preset }"></ng-container>
      </div>

      <!-- Preset Type Row -->
      <div class="flex items-center justify-between">
        <span class="text-gray-600 text-sm">Preset Type</span>
        <ng-container *ngTemplateOutlet="presetTypeTemplate; context: { $implicit: preset }"></ng-container>
      </div>

      <!-- Thermostats Row -->
      <div class="flex items-center justify-between">
        <span class="text-gray-600 text-sm">Devices</span>
        <sbnb-thermostats
          [allThermostats]="false"
          [thermostats]="preset.thermostats"
          [thermostatName]="preset.name"></sbnb-thermostats>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- Shared Templates -->
<ng-template #toggleTemplate let-element>
  <mat-slide-toggle
    [checked]="element.is_active"
    [disabled]="element.is_default"
    (click)="$event.stopPropagation()"
    (change)="activateOrDeactivateThermostatPreset(element, $event)"
    data-element="thermostat-preset-toggle"></mat-slide-toggle>
</ng-template>

<ng-template #setPointsTemplate let-element>
  <div class="flex items-center gap-3">
    <div
      class="flex items-center gap-2"
      *ngIf="element.hvac_mode_setting === 'heat' || element.hvac_mode_setting === 'heat_cool'">
      <sbnb-icon icon="matches-fire" class="text-coral"></sbnb-icon>
      {{ element.heating_set_point_fahrenheit }}°F
    </div>

    <div
      class="flex items-center gap-2"
      *ngIf="element.hvac_mode_setting === 'cool' || element.hvac_mode_setting === 'heat_cool'">
      <sbnb-icon icon="temperature-snowflake" class="text-aqua"></sbnb-icon>
      {{ element.cooling_set_point_fahrenheit }}°F
    </div>
  </div>
</ng-template>

<ng-template #fanTemplate let-element>
  <div class="relative flex items-center gap-2">
    <sbnb-icon icon="mode-fan" [size]="22"></sbnb-icon>
    <span class="px-2 py-1 text-xs bg-gray-100 rounded-full">
      {{ element.fan_mode_setting }}
    </span>
  </div>
</ng-template>

<ng-template #presetTypeTemplate let-element>
  <div class="relative flex items-center gap-2">
    <sbnb-icon [icon]="getPresetIcon(element.type)" [size]="22" class="text-gray-600"></sbnb-icon>
    {{ getPresetType(element.type) }}
  </div>
</ng-template>
